module.exports = __webpack_public_path__ + "d800f0ce999ed2709853e5ece933d89a.svg";